module.exports = __webpack_public_path__ + "img/250-502501.png";